import { render, staticRenderFns } from "./portfolio_index.vue?vue&type=template&id=0be39b34&scoped=true&"
import script from "./portfolio_index.vue?vue&type=script&lang=js&"
export * from "./portfolio_index.vue?vue&type=script&lang=js&"
import style0 from "./portfolio_index.vue?vue&type=style&index=0&id=0be39b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be39b34",
  null
  
)

export default component.exports